import type { MaterializedMenuProduct } from '@jane/shared/types';

import { janeApi } from '../api/janeApi';

interface MaterializedMenuProductProps {
  productId: number;
  storeId: number;
}
const materializedMenuProductUrl = ({
  productId,
  storeId,
}: MaterializedMenuProductProps) =>
  `/materialized_menu_products?store_id=${storeId}&product_id=${productId}`;

export const fetchMaterializedMenuProduct = async ({
  productId,
  storeId,
}: MaterializedMenuProductProps): Promise<MaterializedMenuProduct> => {
  return await janeApi
    .get<MaterializedMenuProduct>(
      materializedMenuProductUrl({ productId, storeId })
    )
    .then((result) => result);
};
